import { PaletteOptions } from '@mui/material';

export const sparqPalette: PaletteOptions = {
  primary: {
    main: '#3365FF',
    dark: '#0047BB',
  },
  black: {
    main: '#000000',
  },
  appGrey: {
    buttonBorder: '#9B9B9B',
    darkGray: '#808080',
    dragAndDropBoxShadow: 'rgba(0,71,187,0.1)',
    filterArrayButtonHoverColor: '#494949',
    greyPrimary: '#CCCCCC',
    lightSilver: '#D8D8D8',
    whiteSmoke: '#F4F4F4',
    sideMenuActiveBackground: '#f3f4f9',
    filtersButtonBorder: '#c7c7c7',
  },
  error: {
    main: '#FF0000',
    dark: '#d32f2f',
  },
  appWhite: {
    main: '#FFFFFF',
    sideBarMenuContainerBgColor: '#F4F4F4',
    sideBarMenuItemActive: '#F9F9F9',
  },
};
